import React from 'react';
import PropTypes from 'prop-types';
import SearchIcon from '@material-ui/icons/Search';
import { useTranslation } from '../../src/i18n';
import FormikAutocompleteSelect from '../Fields/FormikAutocompleteSelect';

const AutocompleteSearchField = ({
  className,
  label,
  placeholder,
  onChange,
  onInputTextChange,
  options,
  isLoading,
  onFocus,
  field: { name, value },
  ...rest
}) => {
  const { t } = useTranslation();
  const [startAggregations, setStartAggregations] = React.useState(false);

  React.useEffect(() => {
    setStartAggregations(false);
  }, [options]);

  return (
    <FormikAutocompleteSelect
      className={className}
      instanceId={name}
      label={t(label)}
      field={{
        name,
        value,
      }}
      placeholder={t(placeholder)}
      onChange={onChange}
      onInputTextChange={v => {
        onInputTextChange(v);
        setStartAggregations(true);
      }}
      options={options}
      isLoading={isLoading}
      isClearable
      isEditable
      customComponents={{
        DropdownIndicator: () => <SearchIcon />,
      }}
      onFocus={() => {
        onFocus('');
        setStartAggregations(true);
      }}
      startAggregations={startAggregations}
      {...rest}
    />
  );
};

AutocompleteSearchField.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  field: PropTypes.shape({
    name: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
  }),
  placeholder: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onInputTextChange: PropTypes.func.isRequired,
  options: PropTypes.array,
  isLoading: PropTypes.bool,
  onFocus: PropTypes.func,
};

AutocompleteSearchField.defaultProps = {
  className: '',
  label: '',
  placeholder: '',
  options: [],
  isLoading: false,
  onFocus: () => {},
};

export default AutocompleteSearchField;
